<template>
  <div v-if="isLocked">
    <span class="label label-danger">{{ $i18n.t('Locked by') }}: {{ username }} {{ lockTime | date }}</span>
  </div>
</template>

<script>
import { formatDateTime } from '../../filters/date'

/**
 * @class FormLockStore
 *
 * @description This component is the state handler/wrapper for FormLock
 */
export default {
  name: 'form-lock-store',
  filters: {
    date: function (value) {
      return formatDateTime(value)
    },
  },
  computed: {
    username() {
      if (!this.usernameHidden) {
        return this.lockUserName + ' - ' + this.lockUserEmail + ' @ '
      } else {
        return ''
      }
    },
    lock() {
      return this.$get('formLock')
    },
    isLocked() {
      return this.lock.isLocked
    },
    lockUserName() {
      return this.lock.lockUserName
    },
    lockUserEmail() {
      return this.lock.lockUserEmail
    },
    lockTime() {
      return this.lock.lockTime
    },
    usernameHidden() {
      return this.$get('usernameHidden')
    },
  },
}
</script>
